import { useState, useEffect } from 'react';
import { PromptMomentNotification } from 'google-one-tap';
import { initGoogleOneTap, loadGoogleOneTapClient } from '../../utils/googleOneTap';
import { AuthenticationResponse } from '../../shared/constants/authenticationFlow';

interface UseGoogleOneTapProps {
    googleClientId: string;
    onSdkLoadSuccess?: () => void;
    onSdkLoadError?: () => void;
    onOneTapCallback?: () => void;
    onOneTapSuccess: (response: AuthenticationResponse) => void;
    onOneTapError: (response: AuthenticationResponse) => void;
    onNotificationReceived: (notification: PromptMomentNotification) => void;
    isFedCMAvailable?: boolean;
}

export const useGoogleOneTap = ({
    googleClientId,
    onNotificationReceived,
    onSdkLoadSuccess,
    onSdkLoadError,
    onOneTapCallback,
    onOneTapSuccess,
    onOneTapError,
    isFedCMAvailable,
}: UseGoogleOneTapProps) => {
    const [isSdkLoaded, setIsSdkLoaded] = useState(false);

    useEffect(() => {
        const handleSuccess = () => {
            onSdkLoadSuccess?.();
            setIsSdkLoaded(true);
        };

        if (!googleClientId) {
            return;
        }

        loadGoogleOneTapClient(googleClientId, handleSuccess, onSdkLoadError);
    }, [onSdkLoadSuccess, onSdkLoadError, setIsSdkLoaded, googleClientId]);

    useEffect(() => {
        if (isSdkLoaded) {
            initGoogleOneTap({
                onOneTapSuccess,
                onOneTapError,
                onOneTapCallback,
                onNotificationReceived,
                googleClientId,
                isFedCMAvailable,
            });
        }
    }, [
        isSdkLoaded,
        onOneTapCallback,
        onOneTapSuccess,
        onOneTapError,
        onNotificationReceived,
        googleClientId,
        isFedCMAvailable,
    ]);

    return {
        isSdkLoaded,
    };
};
